import React, {memo } from 'react';
import useStyles from '../styles/Styles';
import { styled } from '@mui/material/styles';

import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Rifm } from 'rifm'; 

import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';

import _ from 'lodash';
import {isTrue, fixedOptions} from '../utils';

const FormField = memo((props) => {
	const classes = useStyles();
	
	const required = _.isNil(props.required) ? false : props.required;
	
	const ReadOnlyTextField = styled(TextField)(({theme}) => ({
		'& .MuiFormLabel-root.MuiInputLabel-root': {
			color: theme.palette.text.secondary,
		},
		'& .MuiInputBase-input.Mui-disabled': {
			color: theme.palette.text.primary,
			WebkitTextFillColor: theme.palette.text.primary,
			backgroundColor: theme.palette.tertiary.pale,
			
		},
		'& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
			borderColor: 'transparent',
		},
	}));
	
	switch(props.type){
		case 'checkbox':
			return (<FormControlLabel
				control={
					<Checkbox
					onChange={(event) => props.handleChange(props.id, event.target.checked)}
					checked={isTrue(props.value)}
					color="primary"
				  />
				}
				label={props.label}
			  />);
		case 'date':
			const minDate = props.minDate || '1900-01-01';
			const maxDate = props.maxDate || '2100-01-01';
			return (<DatePicker 
					closeOnSelect={true}
					className={classes.datePicker}
					InputAdornmentProps={{position: "end"}}
					inputFormat={props.format || 'DD/MM/YYYY'}
					minDate={minDate}
					maxDate={maxDate}
					value={props.value}
					onChange={(date) => props.handleChange(props.id, date)}
					label={props.label}
					renderInput={(params) => <TextField {...params}
						required={required}
						fullWidth
						error={props.error}
						helperText={props.error ? props.message : ''}
						placeholder={props.placeholder}
					/>}
				/>);
		case 'masked':
			return (
                <Rifm 
                    format={props.format}
                    accept={/\d+/g}
                    value={props.value}
                    onChange={(val) => props.handleChange(props.id, val)}
                    >
                    {({ value, onChange }) => (
                      <TextField
                        variant="outlined"
                        fullWidth
                        error={props.error}
                        helperText={props.message}
                        label={props.label}
                        //required={_.isNil(props.required) ? false : props.required}
                        value={value}
                        onChange={onChange}
                      />
                    )}
                </Rifm>
            ); 
		case 'select':
			const options = _.isObject(props.options) ? props.options : fixedOptions(props.options);
			return (<TextField
				variant="outlined"
				fullWidth
				select
				error={props.error}
				helperText={props.error ? props.message : ''}
				onChange={(event) => props.handleChange(props.id, event.target.value)}
				label={props.label}
				required={required}
				value={props.value}
			>
			{_.map(options, (v, k) => (
				<MenuItem key={k} value={k}>{v}</MenuItem>
			))}
			</TextField>);
		case 'read-only':
			return (<ReadOnlyTextField
				variant="outlined"
				fullWidth
				disabled
				label={props.label}
				value={_.isNil(props.display_value) ? props.value : props.display_value}
				multiline={_.isNil(props.multiline) ? false : true}
			/>);
		default:
			return (<TextField
				variant="outlined"
				fullWidth
				error={props.error}
				helperText={props.message}
				value={props.value}
				label={props.label}
				onChange={(event) => props.handleChange(props.id, event.target.value)}
				required={required}
			/>)
	}

})

export default FormField;